"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiocType = void 0;
var FiocType;
(function (FiocType) {
    FiocType["EXPIRED"] = "EXPIRED";
    FiocType["NON_EXPIRED"] = "NON_EXPIRED";
})(FiocType || (exports.FiocType = FiocType = {}));
//# sourceMappingURL=index.js.map